module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agenda/components/agenda-sidebar-event-types/template.html
// module id = 2aAy
// module chunks = 0